module.exports = __webpack_public_path__ + "static/media/step_015.71d09338.jpeg";